const Button = {
    baseStyle: {
        fontWeight: 400,
        _focus: { boxShadow: "none" }
    }
};

export default Button;